import type { FC } from "react";
import React from "react";

import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
} from "@react/ui-primitives/drawer";

interface ReceiptCaptureSheetProps {
  readonly onOpenChange: (open: boolean) => void;
  readonly open: boolean;
}

export const ReceiptCaptureSheet: FC<ReceiptCaptureSheetProps> = ({
  onOpenChange,
  open,
}) => (
  <Drawer onOpenChange={onOpenChange} open={open}>
    <DrawerContent>
      <DrawerHeader>
        <DrawerTitle>Scan a receipt</DrawerTitle>
        <DrawerDescription>
          Receipt capture is not yet implemented.
        </DrawerDescription>
      </DrawerHeader>
      <p className="px-4 pb-8 text-sm text-muted-foreground">
        Snapping a receipt to add several items at once is coming soon. For now,
        scan a barcode or add a purchase by hand.
      </p>
    </DrawerContent>
  </Drawer>
);
